/**
 * Shortens the Shopify Customer Privacy banner copy on phones, where the default
 * sentence wraps to five lines and pushes the card over the hero image.
 *
 * The copy is not theme-editable and Shopify injects (and can re-render) the banner,
 * hence the observers. The original policy link element is reused rather than
 * recreated, and non-English storefronts are left on Shopify's translated copy.
 */
(function () {
  var SHORT_COPY = 'We use cookies for personalization, marketing, and analytics. Learn more in our ';
  var mobile = window.matchMedia('(max-width: 749px)');
  var watchedBanner = null;
  var bannerObserver = null;
  var originalHtml = null;

  function isEnglish() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  }

  function getParagraph() {
    return document.querySelector('#shopify-pc__banner .shopify-pc__banner__body p');
  }

  function sync() {
    var paragraph = getParagraph();
    if (!paragraph) return;

    var isShortened = paragraph.dataset.chakrikkaShortened === 'true';

    if (mobile.matches && !isShortened) {
      var link = paragraph.querySelector('a');
      // Without the policy link the full copy is all the user has, so leave it alone.
      if (!link) return;

      originalHtml = paragraph.innerHTML;
      paragraph.textContent = SHORT_COPY;
      paragraph.appendChild(link);
      paragraph.dataset.chakrikkaShortened = 'true';
    } else if (!mobile.matches && isShortened && originalHtml !== null) {
      paragraph.innerHTML = originalHtml;
      delete paragraph.dataset.chakrikkaShortened;
    }
  }

  function watchBanner(banner) {
    if (bannerObserver) bannerObserver.disconnect();
    watchedBanner = banner;
    bannerObserver = new MutationObserver(sync);
    bannerObserver.observe(banner, { childList: true, subtree: true });
    sync();
  }

  function init() {
    if (!isEnglish()) return;

    var banner = document.getElementById('shopify-pc__banner');
    if (banner) watchBanner(banner);

    new MutationObserver(function () {
      var current = document.getElementById('shopify-pc__banner');
      if (current && current !== watchedBanner) watchBanner(current);
    }).observe(document.body, { childList: true });

    if (mobile.addEventListener) {
      mobile.addEventListener('change', sync);
    } else if (mobile.addListener) {
      mobile.addListener(sync);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
